import * as i0 from '@angular/core';
import { Injectable, Directive, Optional, SkipSelf, Input, HostBinding, NgModule } from '@angular/core';
import { BehaviorSubject, of, fromEvent, merge, combineLatest } from 'rxjs';
import { debounceTime, map, filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
var GridColumnsDefaultValue;
(function (GridColumnsDefaultValue) {
    GridColumnsDefaultValue[GridColumnsDefaultValue["DESKTOP"] = 12] = "DESKTOP";
    GridColumnsDefaultValue[GridColumnsDefaultValue["MOBILE"] = 2] = "MOBILE";
    GridColumnsDefaultValue[GridColumnsDefaultValue["TABLET"] = 8] = "TABLET";
})(GridColumnsDefaultValue || (GridColumnsDefaultValue = {}));
var GridGutter;
(function (GridGutter) {
    GridGutter["SMALL"] = "8px";
    GridGutter["DEFAULT"] = "12px";
})(GridGutter || (GridGutter = {}));
var GridLayoutMargin;
(function (GridLayoutMargin) {
    GridLayoutMargin["MOBILE_SMALL"] = "8px";
    GridLayoutMargin["MOBILE_LARGE"] = "12px";
    GridLayoutMargin["TABLET_VERTICAL"] = "28px";
    GridLayoutMargin["TABLET_HORIZONTAL"] = "76px";
    GridLayoutMargin["DESKTOP"] = "auto";
})(GridLayoutMargin || (GridLayoutMargin = {}));
var GridLayoutPadding;
(function (GridLayoutPadding) {
    GridLayoutPadding["DEFAULT"] = "0px";
    GridLayoutPadding["SMALL"] = "8px";
    GridLayoutPadding["LARGE"] = "68px";
})(GridLayoutPadding || (GridLayoutPadding = {}));
class ColumnInfoService {
    constructor() {
        this.layoutColumnsSubject = new BehaviorSubject(null);
        this.layoutColumns$ = this.layoutColumnsSubject.asObservable();
    }
    setColumns(desktop, tablet, mobile) {
        this.layoutColumnsSubject.next({
            desktop,
            tablet,
            mobile
        });
    }
}
ColumnInfoService.ɵfac = function ColumnInfoService_Factory(t) { return new (t || ColumnInfoService)(); };
ColumnInfoService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ColumnInfoService_Factory() { return new ColumnInfoService(); }, token: ColumnInfoService, providedIn: "root" });
ColumnInfoService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ColumnInfoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

var ScreenSize;
(function (ScreenSize) {
    ScreenSize["XS"] = "xs";
    ScreenSize["S"] = "sm";
    ScreenSize["M"] = "md";
    ScreenSize["L"] = "lg";
})(ScreenSize || (ScreenSize = {}));
var GridLayout;
(function (GridLayout) {
    GridLayout["MOBILE_SMALL"] = "mob-sm";
    GridLayout["MOBILE_LARGE"] = "mob-lg";
    GridLayout["TABLET_VERTICAL"] = "tab-v";
    GridLayout["TABLET_HORIZONTAL"] = "tab-h";
    GridLayout["DESKTOP_SMALL"] = "desk-sm";
    GridLayout["DESKTOP_MEDIUM"] = "desk-md";
    GridLayout["DESKTOP_LARGE"] = "desk-lg";
})(GridLayout || (GridLayout = {}));
class ResponsiveService {
    constructor() {
        const initialScreenWidth$ = of(window.innerWidth);
        const onResizeScreenWidth$ = fromEvent(window, 'resize').pipe(debounceTime(200), map((evt) => evt.target.innerWidth));
        this.screenWidth$ = merge(initialScreenWidth$, onResizeScreenWidth$);
        this.mediaBreakpoint$ = this.screenWidth$.pipe(map((screenWidth) => ResponsiveService.computeMediaBreakpoint(screenWidth)));
        this.isMobile$ = this.mediaBreakpoint$.pipe(map((layout) => layout === GridLayout.MOBILE_LARGE ||
            layout === GridLayout.MOBILE_SMALL ||
            layout === GridLayout.TABLET_VERTICAL ||
            layout === GridLayout.TABLET_HORIZONTAL));
    }
    static computeMediaBreakpoint(width) {
        if (width <= 320) {
            return GridLayout.MOBILE_SMALL;
        }
        else if (width >= 321 && width < 505) {
            return GridLayout.MOBILE_LARGE;
        }
        else if (width >= 505 && width < 769) {
            return GridLayout.TABLET_VERTICAL;
        }
        else if (width >= 769 && width < 1024) {
            return GridLayout.TABLET_HORIZONTAL;
        }
        else if (width >= 1024 && width < 1321) {
            return GridLayout.DESKTOP_SMALL;
        }
        else if (width >= 1321 && width < 1440) {
            return GridLayout.DESKTOP_MEDIUM;
        }
        else {
            return GridLayout.DESKTOP_LARGE;
        }
    }
}
ResponsiveService.ɵfac = function ResponsiveService_Factory(t) { return new (t || ResponsiveService)(); };
ResponsiveService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ResponsiveService, factory: ResponsiveService.ɵfac });
ResponsiveService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResponsiveService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Directive to be added to div HTML elements that must be wrap by the layout directive.
 */
class ColumnDirective {
    constructor(responsiveService, columnInfoService, columnParentInfoService) {
        this.responsiveService = responsiveService;
        this.columnInfoService = columnInfoService;
        this.columnParentInfoService = columnParentInfoService;
        this.subscriptions = [];
        this.columnClass = true;
    }
    get isClassWidthEnabled() {
        return this.widthCssExpression;
    }
    get gutter() {
        return this.gutterCssExpression;
    }
    get display() {
        return this.displayCssExpression;
    }
    ngOnInit() {
        this.columnInfoService.setColumns(this.desktop, this.tablet, this.mobile);
        this.subscriptions.push(combineLatest([
            this.responsiveService.mediaBreakpoint$,
            this.columnInfoService.layoutColumns$,
            this.columnParentInfoService.layoutColumns$
        ])
            .pipe(filter(([, layout]) => layout.mobile != null &&
            layout.tablet != null &&
            layout.desktop != null), map(([mediaBreakpoint, layout, parentLayout]) => {
            const gutter = mediaBreakpoint === GridLayout.MOBILE_SMALL
                ? GridGutter.SMALL
                : GridGutter.DEFAULT;
            if (mediaBreakpoint === GridLayout.MOBILE_SMALL ||
                mediaBreakpoint === GridLayout.MOBILE_LARGE) {
                return [
                    layout.mobile <=
                        (parentLayout && parentLayout.mobile
                            ? parentLayout.mobile
                            : GridColumnsDefaultValue.MOBILE)
                        ? `calc(${(layout.mobile /
                            (parentLayout && parentLayout.mobile
                                ? parentLayout.mobile
                                : GridColumnsDefaultValue.MOBILE)) *
                            100}% - ${gutter} - ${gutter})`
                        : `calc(100% - ${gutter} - ${gutter})`,
                    layout.mobile === 0 ? 'none' : undefined
                ];
            }
            else if (mediaBreakpoint === GridLayout.TABLET_VERTICAL ||
                mediaBreakpoint === GridLayout.TABLET_HORIZONTAL) {
                return [
                    layout.tablet <=
                        (parentLayout && parentLayout.tablet
                            ? parentLayout.tablet
                            : GridColumnsDefaultValue.TABLET)
                        ? `calc(${(layout.tablet /
                            (parentLayout && parentLayout.tablet
                                ? parentLayout.tablet
                                : GridColumnsDefaultValue.TABLET)) *
                            100}% - ${gutter} - ${gutter})`
                        : `calc(100% - ${gutter} - ${gutter})`,
                    layout.tablet === 0 ? 'none' : undefined
                ];
            }
            else {
                return [
                    layout.desktop <=
                        (parentLayout && parentLayout.desktop
                            ? parentLayout.desktop
                            : GridColumnsDefaultValue.DESKTOP)
                        ? `calc(${(layout.desktop /
                            (parentLayout && parentLayout.desktop
                                ? parentLayout.desktop
                                : GridColumnsDefaultValue.DESKTOP)) *
                            100}% - ${gutter} - ${gutter})`
                        : `calc(100% - ${gutter} - ${gutter})`,
                    layout.desktop === 0 ? 'none' : undefined
                ];
            }
        }))
            .subscribe(([widthCssExpression, displayCssExpression]) => {
            this.displayCssExpression = displayCssExpression;
            this.widthCssExpression = widthCssExpression;
        }), this.responsiveService.mediaBreakpoint$
            .pipe(map((mediaBreakpoint) => mediaBreakpoint === GridLayout.MOBILE_SMALL
            ? GridGutter.SMALL
            : GridGutter.DEFAULT), map((gutterPixels) => `0 ${gutterPixels}`))
            .subscribe((gutterCssExpression) => {
            this.gutterCssExpression = gutterCssExpression;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
}
ColumnDirective.ɵfac = function ColumnDirective_Factory(t) { return new (t || ColumnDirective)(ɵngcc0.ɵɵdirectiveInject(ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ColumnInfoService), ɵngcc0.ɵɵdirectiveInject(ColumnInfoService, 12)); };
ColumnDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ColumnDirective, selectors: [["", "onepColumn", ""]], hostVars: 8, hostBindings: function ColumnDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.isClassWidthEnabled)("margin", ctx.gutter)("display", ctx.display);
        ɵngcc0.ɵɵclassProp("uikit-column", ctx.columnClass);
    } }, inputs: { mobile: "mobile", tablet: "tablet", desktop: "desktop" }, features: [ɵngcc0.ɵɵProvidersFeature([ColumnInfoService])] });
ColumnDirective.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ColumnInfoService },
    { type: ColumnInfoService, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
ColumnDirective.propDecorators = {
    mobile: [{ type: Input }],
    tablet: [{ type: Input }],
    desktop: [{ type: Input }],
    isClassWidthEnabled: [{ type: HostBinding, args: ['style.width',] }],
    gutter: [{ type: HostBinding, args: ['style.margin',] }],
    display: [{ type: HostBinding, args: ['style.display',] }],
    columnClass: [{ type: HostBinding, args: ['class.uikit-column',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ColumnDirective, [{
        type: Directive,
        args: [{
                selector: '[onepColumn]',
                providers: [ColumnInfoService]
            }]
    }], function () { return [{ type: ResponsiveService }, { type: ColumnInfoService }, { type: ColumnInfoService, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, { columnClass: [{
            type: HostBinding,
            args: ['class.uikit-column']
        }], isClassWidthEnabled: [{
            type: HostBinding,
            args: ['style.width']
        }], gutter: [{
            type: HostBinding,
            args: ['style.margin']
        }], display: [{
            type: HostBinding,
            args: ['style.display']
        }], mobile: [{
            type: Input
        }], tablet: [{
            type: Input
        }], desktop: [{
            type: Input
        }] }); })();

/**
 * Directive to be added to div HTML elements and must be wrap the columns directives.
 */
class LayoutDirective {
    constructor(responsiveService, columnInfoService) {
        this.responsiveService = responsiveService;
        this.columnInfoService = columnInfoService;
        this.layoutClass = true;
        this.subscriptions = [];
    }
    get marginLeft() {
        return this.marginCssExpression;
    }
    get marginRight() {
        return this.marginCssExpression;
    }
    get paddingLeft() {
        return this.paddingCssExpression;
    }
    get paddingRight() {
        return this.paddingCssExpression;
    }
    ngOnInit() {
        this.subscriptions.push(combineLatest([
            this.responsiveService.mediaBreakpoint$,
            this.columnInfoService.layoutColumns$
        ])
            .pipe(map(([mediaBreakpoint, parentLayoutColumns]) => {
            let layoutMargin;
            let layoutPadding = GridLayoutPadding.DEFAULT;
            switch (mediaBreakpoint) {
                // Gutter size is already deducted.
                case GridLayout.MOBILE_SMALL:
                    layoutMargin = GridLayoutMargin.MOBILE_SMALL;
                    break;
                case GridLayout.MOBILE_LARGE:
                    layoutMargin = GridLayoutMargin.MOBILE_LARGE;
                    break;
                case GridLayout.TABLET_VERTICAL:
                    layoutMargin = GridLayoutMargin.TABLET_VERTICAL;
                    break;
                case GridLayout.TABLET_HORIZONTAL:
                    layoutMargin = GridLayoutMargin.TABLET_HORIZONTAL;
                    break;
                default:
                case GridLayout.DESKTOP_MEDIUM:
                case GridLayout.DESKTOP_SMALL:
                    layoutMargin = GridLayoutMargin.DESKTOP;
                    layoutPadding = GridLayoutPadding.SMALL;
                    break;
                case GridLayout.DESKTOP_LARGE:
                    layoutMargin = GridLayoutMargin.DESKTOP;
                    layoutPadding = GridLayoutPadding.LARGE;
                    break;
            }
            const gutter = mediaBreakpoint === GridLayout.MOBILE_SMALL
                ? GridGutter.SMALL
                : GridGutter.DEFAULT;
            return parentLayoutColumns
                ? [`-${gutter}`, undefined]
                : [
                    !this.noMargin ? layoutMargin : `-${gutter}`,
                    !this.noMargin ? layoutPadding : undefined
                ];
        }))
            .subscribe(([marginCssExpression, paddingCssExpression]) => {
            this.marginCssExpression = marginCssExpression;
            this.paddingCssExpression = paddingCssExpression;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
}
LayoutDirective.ɵfac = function LayoutDirective_Factory(t) { return new (t || LayoutDirective)(ɵngcc0.ɵɵdirectiveInject(ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ColumnInfoService)); };
LayoutDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LayoutDirective, selectors: [["", "onepLayout", ""]], hostVars: 10, hostBindings: function LayoutDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("margin-left", ctx.marginLeft)("margin-right", ctx.marginRight)("padding-left", ctx.paddingLeft)("padding-right", ctx.paddingRight);
        ɵngcc0.ɵɵclassProp("uikit-layout", ctx.layoutClass);
    } }, inputs: { noMargin: "noMargin" } });
LayoutDirective.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ColumnInfoService }
];
LayoutDirective.propDecorators = {
    noMargin: [{ type: Input }],
    layoutClass: [{ type: HostBinding, args: ['class.uikit-layout',] }],
    marginLeft: [{ type: HostBinding, args: ['style.margin-left',] }],
    marginRight: [{ type: HostBinding, args: ['style.margin-right',] }],
    paddingLeft: [{ type: HostBinding, args: ['style.padding-left',] }],
    paddingRight: [{ type: HostBinding, args: ['style.padding-right',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LayoutDirective, [{
        type: Directive,
        args: [{
                selector: '[onepLayout]'
            }]
    }], function () { return [{ type: ResponsiveService }, { type: ColumnInfoService }]; }, { layoutClass: [{
            type: HostBinding,
            args: ['class.uikit-layout']
        }], marginLeft: [{
            type: HostBinding,
            args: ['style.margin-left']
        }], marginRight: [{
            type: HostBinding,
            args: ['style.margin-right']
        }], paddingLeft: [{
            type: HostBinding,
            args: ['style.padding-left']
        }], paddingRight: [{
            type: HostBinding,
            args: ['style.padding-right']
        }], noMargin: [{
            type: Input
        }] }); })();

/**
 * Module that provides the components to organize the layout of an app.
 */
class GridModule {
    static forRoot() {
        return {
            ngModule: GridModule,
            providers: [ResponsiveService]
        };
    }
}
GridModule.ɵfac = function GridModule_Factory(t) { return new (t || GridModule)(); };
GridModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: GridModule });
GridModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GridModule, [{
        type: NgModule,
        args: [{
                declarations: [ColumnDirective, LayoutDirective],
                imports: [CommonModule],
                exports: [ColumnDirective, LayoutDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GridModule, { declarations: function () { return [ColumnDirective, LayoutDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ColumnDirective, LayoutDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ColumnDirective, GridLayout, GridModule, LayoutDirective, ResponsiveService, ScreenSize, ColumnInfoService as ɵa };

